import { http } from '../../config/axios'

export default function putMotorCreditoRegra(motorCreditoRegra: any): Promise<string> {
  return http
    .put('api/motorcredito', motorCreditoRegra)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put motor credito regra', error)
      throw Error(error.response.data)
    })
}
